module.exports = __webpack_public_path__ + "static/media/sp-logo-final.a7d29fbb.svg";